import environment from "@menu-environment";
import { StringDictionary } from "@menu/core/types/string-dictionary";
import analyticsConfig from "core/analytics-config";

export type AnalyticsMetaData = {
  component_name: string;
  component_type: string;
}

const w = (window as any);

export const addAnalyticsToDataLayer = (data: any) => {
  if (w?.dataLayer) {
    w.dataLayer.push(data);
  }
}

export const getAnalyticsModel = (meta: AnalyticsMetaData, replacements: Record<string, string> = {}) => {
  if (environment.disableAnalytics) {
    return {};
  }
  if (!meta.component_name) {
    console.warn("Analytics - component name is missing: ", meta);
    return {};
  }

  const properties = Object.keys(meta);

  const dict: StringDictionary = {};

  properties.forEach(key => {
    const metaKey = key as keyof typeof meta;
    let value = meta[metaKey];

    replacements && Object.keys(replacements).forEach(replacementKey => {
      value = value.replace(`{${replacementKey}}`, replacements[replacementKey]);
    });

    dict[key] = value.toLowerCase();
  });

  dict.current_page_url = window.location.href;
  dict.target_page_url = "_self";

  return dict;
}

const getAnalyticTags = (meta: AnalyticsMetaData, replacements: Record<string, string> = {}) => {
  if (environment.disableAnalytics) {
    return {};
  }

  if (!meta.component_name) {
    console.warn("Analytics - component name is missing: ", meta);
    return {};
  }

  const dict = getAnalyticsModel(meta, replacements);

  const info = JSON.stringify(dict);

  return {
    "data-component-name": dict.component_name,
    "data-component-info": info
  };
}

export const AnalyticsHelper = {
  handleSearch: (needle: string) => {
    const vars: Record<string, string> = {
      name: needle
    }

    const meta = analyticsConfig.search;

    const data = getAnalyticsModel(meta, vars);

    addAnalyticsToDataLayer(data);
  },
  search: (name: string) => {
    const vars: Record<string, string> = {
      name: name
    }

    const meta = analyticsConfig.search;
    return getAnalyticTags(meta, vars);
  },
  callInstaller: (name: string, phone: string) => {
    const vars: Record<string, string> = {
      name: name,
      telephone: phone
    }

    const meta = analyticsConfig.callInstaller;
    return getAnalyticTags(meta, vars);
  },
  directions: (name: string, address: string, url: string) => {
    const vars: Record<string, string> = {
      name: name,
      address: address,
      url: url
    };

    const meta = analyticsConfig.directions;
    return getAnalyticTags(meta, vars);
  },
  copyToClipboard: (name: string, phone: string) => {
    const vars: Record<string, string> = {
      name: name,
      telephone: phone
    }

    const meta = analyticsConfig.copyToClipboard;
    return getAnalyticTags(meta, vars);
  }
}

export { analyticsConfig };
export default getAnalyticTags;
